import React from 'react';
import { Typography } from 'antd';
const { Text } = Typography;

export const PageTitle = (props: any) => {
  return <h1 className="text-toolbox-secondary text-4xl font-bold mb-0 leading-thight">{props.children}</h1>;
};

export const PageAboveTitle = (props: any) => {
  return <h2 className="text-toolbox-primary text-sm leading-snug pt-1 mb-4">{props.children}</h2>;
};

export const PageDescription = (props: any) => {
  return <p className="text-toolbox-descriptions text-lg font-light m-0 leading-snug">{props.children}</p>;
};

export const SideBarTitle = (props: any) => {
  return <h2 className="text-toolbox-secondary text-base font-bold mb-2 ml-6">{props.children}</h2>;
};

export const ModalTitle = (props: any) => {
  return <h3 className="text-toolbox-secondary text-xl font-bold m-0">{props.children}</h3>;
};

export const ModalSubTitle = (props: any) => {
  return <h4 className="text-toolbox-secondary text-lg font-bold m-0 my-2">{props.children}</h4>;
};

export const SectionTitle = (props: any) => {
  return (
    <h4
      className="text-toolbox-secondary font-bold inline-block mb-2"
      style={{
        fontSize: props.fontSize || 20,
      }}>
      {props.children}
    </h4>
  );
};

export const SectionSubTitle = (props: any) => {
  return (
    <Text className="text-toolbox-secondary text-base font-bold" style={{ fontSize: 15 }}>
      {props.children}
    </Text>
  );
};

export const FormItemLabel = (props: any) => {
  return <p className="mb-2">{props.children}</p>;
};
